import { IonButton, IonIcon, IonRouterLink, IonText } from '@ionic/react'
import { chevronForwardOutline } from 'ionicons/icons'
import { observer } from 'mobx-react'
import styled from 'styled-components'

type Props = {
  href?: string
  style?: React.CSSProperties
}

export const CategoryTitle: React.FC<Props> = observer(({ children, href, style }) => {
  return (
    <CategoryTitleWrap style={{ ...style }}>
      <IonText color="dark">
        <p>{children}</p>
      </IonText>
      <IonRouterLink href={href}>
        <IonButton size="small" fill="clear" color="medium">
          <IonText>더보기</IonText>
          <IonIcon slot="end" icon={chevronForwardOutline} />
        </IonButton>
      </IonRouterLink>
    </CategoryTitleWrap>
  )
})

export default CategoryTitle

const CategoryTitleWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 20px;
  margin-bottom: 20px;
  ion-text {
    display: flex;
    align-items: center;
    justify-content: space-between;
    p {
      font-size: 20px;
      font-weight: 900;
      margin: 0;
    }
  }
  ion-button {
    padding: 0;
    margin: 0 5px 0 0;
    ion-text {
      font-size: 15px;
      font-weight: 600;
    }
  }
`
